import * as React from 'react';
import * as ReactSelect from 'rc-select';
import { filterWithoutAccents } from '../utils/utils';

type SelectProps = {
    style?: any;
    className?: string;
    options: Array<Option>;
    multiple?: boolean;
    disableSearch?: boolean;
    disabled?: boolean;
    value: any | Array<any>;
    onChange: (value: any | Array<any>) => void;
    optionComponent?: (opt: Option) => any;
}

export interface Option {
    label: string;
    value: any;
}

const defaultStyle = {
    zIndex: 9999
}

export default class Select extends React.Component<SelectProps, { computedOptions: Map<any, Option> }> {
    private dropDownStyle = {
        width: "100%",
        backgroundColor: this.isDarkMode() ? "#181F3A" : "white"
    };

    state = {
        computedOptions: new Map()
    };
    public constructor(props) {
        super(props);
    }

    updateStyle(props: SelectProps) {
        let style = {
            ...defaultStyle,
            ...this.props.style
        };
        this.dropDownStyle = style;
    }

    componentDidMount() {
        this.updateStyle(this.props);
        this.componentDidUpdate(this.props);
    }

    computedIsFilled = false;

    componentDidUpdate(prevProps: SelectProps) {
        if (!this.computedIsFilled || prevProps.options != this.props.options || JSON.stringify(prevProps.options || {}) != JSON.stringify(this.props.options || {})) {
            this.computedIsFilled = true
            let result = new Map();
            this.props.options.forEach(elt => {
                if (!result.has(elt.value + "")) {
                    result.set(elt.value + "", elt)
                }
            })
            this.setState({
                computedOptions: result
            });
        }
    }

    componentWillReceiveProps(nextProps: SelectProps) {
        if (this.props.style !== nextProps.style)
            this.updateStyle(nextProps);
    }

    isDarkMode() {
        var isTrueSet = 'false';
        if (typeof window !== 'undefined') {
            isTrueSet = localStorage.getItem('isDarkMode');
        }
        if (isTrueSet == 'true') {
            return true;
        }
        return false;
    }

    get selectedOptions(): Array<Option> {
        let values = this.props.value as Array<number>;
        let result: Array<Option>;
        if (Array.isArray(values)) {
            result = values.map(elt => this.state.computedOptions.get(elt + ""));
        } else {
            result = [this.state.computedOptions.get(this.props.value + "")];
        }

        return result.filter(elt => elt);
    }

    handleChange(values: string | Array<string>) {
        let finalResult;
        if (Array.isArray(values)) {
            finalResult = values.map(elt => this.state.computedOptions.get(elt)).filter(elt => elt).map(elt => elt.value);
        } else {
            finalResult = this.state.computedOptions.get(values)?.value;
        }

        this.props.onChange(finalResult);
    }
    public render() {

        let color = this.isDarkMode() ? "white;" : "#181F3A;";
        const css = `
        .rc-select-selection--single .rc-select-selection__rendered {
            color:` + color + `
        }
        `

        return <div>
            <style>{css}</style>
            <ReactSelect.default
                showSearch={this.props.disableSearch ? false : true}
                className={this.props.className}
                disabled={this.props.disabled}
                dropdownStyle={this.dropDownStyle}
                dropdownMenuStyle={{ maxHeight: "300px" }}
                multiple={this.props.multiple || false}
                filterOption={((value: string, option: { key: string }) => {
                    return !option.key || filterWithoutAccents(option.key).toLocaleLowerCase().includes((filterWithoutAccents(value) || "").toLocaleLowerCase());
                }) as any}
                value={!this.props.multiple
                    ? (this.selectedOptions.length !== 0 ? this.selectedOptions[0].label : null)
                    : this.selectedOptions.map(opt => opt.label)}
                onChange={(values: string | Array<string>) => this.handleChange(values)}>
                {Array.from(this.state.computedOptions).map(([key, opt]) =>
                    <ReactSelect.Option
                        key={key}
                        value={key}>
                        {this.props.optionComponent
                            ? this.props.optionComponent(opt)
                            : <div style={{
                                display: "inline-block",
                                color: this.isDarkMode() ? "#FFFFFF" : "rgb(167,170,180)"
                            }}>
                                {opt.label}
                            </div>}
                    </ReactSelect.Option>
                )}
            </ReactSelect.default>
        </div>
    }
}